import React from 'react';
import { motion } from 'framer-motion';
import { DollarSign, Zap, UserCheck, Home } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: DollarSign,
    title: 'Ahorro real',
    description: 'Dejás de comprar todo y empezás a producir parte de tu comida'
  }, {
    icon: Zap,
    title: 'Sistema simple',
    description: 'No improvisás más — seguís pasos claros'
  }, {
    icon: UserCheck,
    title: 'Sin experiencia',
    description: 'Podés empezar desde cero'
  }, {
    icon: Home,
    title: 'Funciona en espacios chicos',
    description: 'Balcón, ventana o cocina'
  }];
  return <section className="w-full py-8 md:py-16 px-4 bg-cream" data-id="element-23">
      <div className="max-w-6xl mx-auto" data-id="element-24">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-bold text-center text-gray-900 mb-8 md:mb-12" data-id="element-25">
          💰 Lo que vas a lograr
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6" data-id="element-26">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 bg-white border-l-4 border-lime-500 p-5 md:p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-27">
              <div className="bg-lime-50 p-3 rounded-xl" data-id="element-28">
                <benefit.icon className="w-5 h-5 md:w-6 md:h-6 text-green-700" data-id="element-29" />
              </div>
              <div data-id="element-30">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-1" data-id="element-31">
                  ✔ {benefit.title}
                </h3>
                <p className="text-sm md:text-base text-gray-700 font-medium" data-id="element-32">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}